import { render, staticRenderFns } from "./OccurrenceTable.vue?vue&type=template&id=17451f8a&scoped=true&"
import script from "./OccurrenceTable.vue?vue&type=script&lang=js&"
export * from "./OccurrenceTable.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceTable.vue?vue&type=style&index=0&id=17451f8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17451f8a",
  null
  
)

export default component.exports